__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-maps-root'].baseUrl;
// Firefox Bug 2016124 fix: Must run BEFORE any other code
/* eslint-disable no-global-assign, no-native-reassign, no-underscore-dangle */
if (typeof window !== 'undefined') {
  // Proxy RegExp to return empty strings for deprecated properties
  // This prevents Intl.js from reading corrupted values from Google Maps
  window.RegExp = new Proxy(window.RegExp, {
    get(target, prop) {
      if (prop === 'lastMatch' || prop === 'leftContext' || prop === 'input') {
        return '';
      }
      if (prop[0] === '$' && prop.length === 2 && prop[1] >= '1' && prop[1] <= '9') {
        return '';
      }
      return target[prop];
    }
  });
  // Disable Intl.js RegExp restore mechanism (if polyfill is loaded)
  if (window.Intl && window.Intl.__disableRegExpRestore) {
    window.Intl.__disableRegExpRestore();
  }
}
/* eslint-disable max-len,eslint-comments/disable-enable-pair,import/first */
import MapsRoot from './components/MapsRoot';
import configureProducts from './products';
import { configureIguazuResources, configureIguazuProcedures } from './iguazu';
configureIguazuProcedures();
configureIguazuResources();
configureProducts();
export default MapsRoot;
;
if (!global.BROWSER) {
  MapsRoot.appConfig = Object.assign({}, MapsRoot.appConfig, {
    appCompatibility: "^5.0.0"
  });
}
;
MapsRoot.appConfig = Object.assign({}, MapsRoot.appConfig, {
  providedExternals: {
    '@americanexpress/react-ddl': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.3.5',
      module: require('@americanexpress/react-ddl')
    },
    '@emotion/core': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '10.3.1',
      module: require('@emotion/core')
    },
    'axp-product-ducks': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.4.20',
      module: require('axp-product-ducks')
    },
    'axp-browser-performance-mark': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '2.3.0',
      module: require('axp-browser-performance-mark')
    },
    '@americanexpress/data-manager-utils': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.3.9',
      module: require('@americanexpress/data-manager-utils')
    },
    'iguazu': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '3.2.0',
      module: require('iguazu')
    },
    'iguazu-graphql': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.3.0',
      module: require('iguazu-graphql')
    },
    'iguazu-holocron': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.8.2',
      module: require('iguazu-holocron')
    },
    'iguazu-rest': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.11.1',
      module: require('iguazu-rest')
    },
    'iguazu-rpc': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.6.1',
      module: require('iguazu-rpc')
    },
    'react-intl': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '5.25.1',
      module: require('react-intl')
    },
    'reactlytics': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '1.2.5',
      module: require('reactlytics')
    },
    '@americanexpress/one-experiments': {
      ...{
        "fallbackEnabled": false,
        "enableFallback": false
      },
      version: '0.3.5',
      module: require('@americanexpress/one-experiments')
    }
  }
});
if (global.getTenantRootModule === undefined || global.rootModuleName && global.rootModuleName === 'axp-maps-root') {
  global.getTenantRootModule = () => MapsRoot;
  global.rootModuleName = 'axp-maps-root';
}